import type { OnInit } from '@angular/core';
import { Directive, ViewContainerRef, inject } from '@angular/core';

/**
 * Allows the InfiniteScrollComponent to observe the height of the items
 * container.
 */
@Directive({ standalone: true, selector: '[flInfiniteScrollContainer]' })
export class InfiniteScrollContainerDirective implements OnInit {
  private viewContainerRef = inject(ViewContainerRef);

  // Host element, this is used by the InfiniteScrollComponent
  container: HTMLElement;

  ngOnInit(): void {
    this.container = this.viewContainerRef.element.nativeElement;
  }
}
